<style lang="stylus">
    .cloudFileNoExist-content
      width 254px
      padding 0 24px 32px
      display flex
      justify-content center
      align-items center
      .item-icon
        width 24px
        height 22px
        margin-right 8px
</style>

<template>
    <Dialog :title="$t('title')" :showFooter="true" :mask="true" :onlyOK="true" @ok="confirm" @close="cancel">
        <div class="cloudFileNoExist-content">
            <iconSymbol class="item-icon" name="small-warn" />
            <span>{{ $t("noExist") }}</span>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";
    @Component({
        components: {
            Dialog,
        },
    })
    export default class Base extends Vue {
        closeModel() {
            this.$store.commit("setDialogState", {
                type: "showColudFileNoExistDialog",
                data: false,
            });
            this.$store.commit("setDialogState", {
                type: "showDialogMask",
                data: false,
            });
        }
        confirm() {
            this.closeModel();
        }
        cancel() {
            this.closeModel();
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "亿图图示文件",
    "noExist": "此文件不存在。"
  },
  "en": {
    "title": "EdrawMax File",
    "noExist": "The file does not exist."
  },
  "jp": {
    "title": "EdrawMaxファイル",
    "noExist": "ファイルが存在しません。"
  },
  "fr": {
    "title": "EdrawMax File",
    "noExist": "Le fichier n'existe pas."
  },
  "de": {
    "title": "EdrawMax-Datei",
    "noExist": "Die Datei existiert nicht."
  },
  "es": {
    "title": "Archivo EdrawMax",
    "noExist": "El archivo no existe."
  },
  "pt": {
    "title": "Ficheiro do EdrawMax",
    "noExist": "O arquivo não existe."
  },
  "it": {
    "title": "File EdrawMax",
    "noExist": "Il file non esiste."
  },
  "tw": {
    "title": "EdrawMax檔案",
    "noExist": "檔案並不存在。"
  },
  "kr": {
    "title": "EdrawMax 파일",
    "noExist": "존재하지 않는 파일입니다."
  }
}
</i18n>
